export const COMPANY_ENDPOINTS = {
  LIST: "/company",
  CREATE: "/company/create",
  LIST_PUBLIC: "/company/public",
  DETAIL: (companyId) => `/company/${companyId}`,
  UPDATE: (companyId) => `/company/${companyId}`,
  GHG_BASELINE_EVIDENCE: (companyId) =>
    `/company/${companyId}/ghg-baseline-evidence`,
};
